import React from "react";
import "./styleIcons.css";

const ArrowScroll = () => {
  return (
    <svg
      width="20"
      height="100"
      className={`arrow-scroll`}
      viewBox="0 0 24 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 2C13.5 1.17157 12.8284 0.5 12 0.5C11.1716 0.5 10.5 1.17157 10.5 2H13.5ZM10.9393 32.0607C11.5251 32.6464 12.4749 32.6464 13.0607 32.0607L22.6066 22.5147C23.1924 21.9289 23.1924 20.9792 22.6066 20.3934C22.0208 19.8076 21.0711 19.8076 20.4853 20.3934L12 28.8787L3.51472 20.3934C2.92893 19.8076 1.97919 19.8076 1.3934 20.3934C0.807611 20.9792 0.807611 21.9289 1.3934 22.5147L10.9393 32.0607ZM10.5 2L10.5 31H13.5L13.5 2H10.5Z"
        fill="#6FFFE9"
      />
    </svg>
  );
};

export default ArrowScroll;
